const ROUTES = {
  "/": {
    "name": "HomePage6a5727f2037d45069d660cb7ee7e4d89",
    "type": "HTML",
    "key": "home-page"
  },
  "/_admin/*": {
    "name": "AdminPagesEa5f882529224a5290ea04d1d2976c00",
    "type": "HTML",
    "key": "admin-pages"
  },
  "/about": {
    "name": "AboutUsPage1585a1baA6cf4f2dA82b502e90616984",
    "type": "HTML",
    "key": "about-us-page"
  },
  "/about/leveling": {
    "name": "AboutLevelingPageB6e762fb9ca8496aA09c9e076575c19c",
    "type": "HTML",
    "key": "about-leveling-page"
  },
  "/events/public": {
    "name": "PublicEventsPage2d5e8210E9fe45a48ba2F8e0ba350b11",
    "type": "HTML",
    "key": "public-events-page"
  },
  "/join": {
    "name": "JoinUsPageB87d80fa626148479d51523e572c0e2e",
    "type": "HTML",
    "key": "join-us-page"
  },
  "/members/*": {
    "name": "MemberPagesA097cee08d8d413aA15c0179f8e61c62",
    "type": "HTML",
    "key": "member-pages"
  },
  "/members/messages/*": {
    "name": "MessagePages57bddf80A95c4b2884a3B6f767211b60",
    "type": "HTML",
    "key": "message-pages"
  },
  "/resources": {
    "name": "ResourcesPageE086908928f44f64B1d2Cb30d11836b4",
    "type": "REFERENCE",
    "key": "resources-page"
  },
  "/signup/*": {
    "name": "SignupPages7b267b6cE53d41b68abcD5338e53f58f",
    "type": "REFERENCE",
    "key": "signup-pages"
  }
};

export default ROUTES;